// extracted by mini-css-extract-plugin
module.exports = {"dialogContentWrapper":"DialogNewReport_dialogContentWrapper__39bly"};